import {userAPI} from '@api/methods/user';

let tokenExpiredCallback: any = null;
let expiryCheckerInterval: any = null;

export const registerTokenExpiredCallback = (callback: any) => {
  tokenExpiredCallback = callback;

  return () => {
    tokenExpiredCallback = null;
  };
};

export const triggerTokenExpired = () => {
  if (tokenExpiredCallback) {
    tokenExpiredCallback();
  }
};

export const checkTokenExpiry = async () => {
  const token = localStorage.getItem('authToken');
  const refreshTokenValue = localStorage.getItem('refreshToken');

  if (token && isTokenExpired(token) && refreshTokenValue) {
    try {
      // Пытаемся обновить токен до истечения срока действия
      const newTokens = await userAPI.refreshToken();
      localStorage.setItem('authToken', newTokens.access_token);
      localStorage.setItem('refreshToken', newTokens.refresh_token);
      console.log('Token refreshed proactively');
    } catch (error) {
      console.log('Proactive token refresh failed:', error);
      if (tokenExpiredCallback) {
        tokenExpiredCallback();
      }
    }
  } else if (token && isTokenExpired(token) && !refreshTokenValue) {
    // Если токен истек и нет refresh token
    if (tokenExpiredCallback) {
      tokenExpiredCallback();
    }
  }
};

export const isTokenExpired = (token: string) => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // конвертируем в миллисекунды
    const buffer = 30000; // 30 секунд буфера
    return Date.now() >= exp - buffer;
  } catch (error) {
    console.error('Error parsing token:', error);
    return true;
  }
};

export const getTokenExpirationTime = (token: string) => {
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  } catch (error) {
    console.error('Error parsing token:', error);
    return null;
  }
};

// Проверяем токен периодически (каждые 30 секунд)
export const startTokenExpiryChecker = () => {
  if (expiryCheckerInterval) {
    clearInterval(expiryCheckerInterval);
  }
  expiryCheckerInterval = setInterval(checkTokenExpiry, 30000);
  checkTokenExpiry();

  return () => {
    if (expiryCheckerInterval) {
      clearInterval(expiryCheckerInterval);
      expiryCheckerInterval = null;
    }
  };
};
